<template lang="pug">
ul.nav
    li.nav-item.inline.dropdown(data-toggle="dropdown")
        a.btn.btn-default(data-toggle="dropdown") Export
        div.dropdown-menu.dropdown-menu-scale.pull-right
            span.dropdown-header Export As
            a.dropdown-item(@click="exportAsFile('CSV')") CSV
            a.dropdown-item(@click="exportAsFile('XLSX')") XLSX
            a.dropdown-item(@click="exportAsFile('PDF')") PDF
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        chart: {
            type: String,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),
    },

    methods: {
        exportAsFile(type) {
            const url = Laroute.route(
                'franchise.report.item.exportChartAsFile',
                {
                    type,
                },
            );

            let params = {
                chart: this.chart,
                outlet_id: this.activeOutlet,
                since: this.startDate.format(),
                until: this.endDate.format(),
            };

            window.open(`${url}?${$.param(params)}`);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/export-chart.vue